/**
 * Container for BlueBar
 *
 * @module containers/BlueBar
 *
 * This container receives actions to render all types of blueBars and returns the appropriate component markup
 */
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import { closeOverlay } from '../../actions/Overlay';
import AccountMessageBar from '../../components/lib/BlueBar/AccountMessage/AccountMessageBar';
import AdBlockerMessageBlueBar from '../../components/lib/BlueBar/AdBlockerMessage/AdBlockerMessageBar';
import BlueBar from '../../components/lib/BlueBar/BlueBar';
import SubscriptionMessage from '../../components/lib/BlueBar/SubscriptionMessage/SubscriptionMessage';
import UnsupportedBrowserBar from '../../components/lib/BlueBar/UnsupportedBrowser/UnsupportedBrowserBar';
import MiniHeader from '../../components/lib/MiniHeader/MiniHeader';
import {
  AccountMessageBlueBarSubtype,
  AdBlockerMessageBlueBarSubtype,
  BrowserBarSubtype,
  OVERLAY_CONFIG,
  OVERLAY_TYPES,
  SubscriptionMessageBlueBarSubtype,
} from '../../constants/Overlay';
import { getHighestPriorityOverlayOfType, shouldShowBlueBar } from '../../lib/Overlay';
import { getUnsupportedBrowserUrl } from '../../lib/RouteUtils';

class BlueBarContainer extends React.Component {
  static propTypes = {
    closeOverlay: PropTypes.func,
    blueBar: PropTypes.object,
    unsupportedBrowserUrl: PropTypes.string,
  };

  determineBlueBar = () => {
    const barToRender = this.props.blueBar;
    if (!barToRender) {
      return false;
    }
    const blueBarProps = {
      // copy over blueBar properties
      ...barToRender[OVERLAY_CONFIG.PROPS],
    };
    blueBarProps.onClose =
      blueBarProps.onClose || (() => this.props.closeOverlay(barToRender[OVERLAY_CONFIG.ID]));
    blueBarProps.unsupportedBrowserUrl = this.props.unsupportedBrowserUrl;
    switch (barToRender[OVERLAY_CONFIG.SUBTYPE]) {
      case BrowserBarSubtype:
        return <UnsupportedBrowserBar {...blueBarProps} />;
      case AccountMessageBlueBarSubtype:
        return <AccountMessageBar {...blueBarProps} />;
      case SubscriptionMessageBlueBarSubtype:
        return <SubscriptionMessage {...blueBarProps} />;
      case AdBlockerMessageBlueBarSubtype:
        return <AdBlockerMessageBlueBar {...blueBarProps} />;
      case 'MiniHeader':
        return <MiniHeader showing={true} {...blueBarProps} />;
      default:
        return <BlueBar {...blueBarProps} />;
    }
  };

  render() {
    return <div className='region-blueBar'>{this.determineBlueBar()}</div>;
  }
}

export function mapStateToProps(state) {
  return {
    blueBar: shouldShowBlueBar(state)
      ? getHighestPriorityOverlayOfType(state, OVERLAY_TYPES.blueBar)
      : null,
    unsupportedBrowserUrl: getUnsupportedBrowserUrl(state),
  };
}

export default connect(mapStateToProps, { closeOverlay })(BlueBarContainer);
